import React, { useState } from "react";
import "../../styles/AiandMlSolutions.css";
import { HiArrowNarrowRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const AIandMLsolutions = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "1. Why is Arshil considered a top AI company?",
      answer:
        "We combine proven expertise with Akscel, our intelligent platform that automates development, integrates seamlessly into CI/CD pipelines, and delivers reliable, scalable AI solutions.",
    },
    {
      question: "2. How quickly can Arshil deliver AI solutions?",
      answer:
        "Akscel accelerates the entire development cycle, reducing delivery times by up to 60% without compromising quality",
    },
    {
      question: "3. Can Arshil work with our existing systems?",
      answer:
        "Yes. Our AI solutions are designed to integrate smoothly with your current applications and workflows.",
    },
    {
      question: "4. What kind of ROI can we expect?",
      answer:
        "By reducing manual work, improving efficiency, and enabling faster decision-making, our solutions drive measurable cost savings and business growth",
    },
  ];

  return (
    <div>
      {/* section 1 */}

      <div className="ai_sec1">
        <h6>AI & ML Solutions</h6>
        <h1>Empower Your Business with Scalable AI & ML Solutions</h1>
        <p>
          AI-powered tools through Akscel, helping businesses enhance
          efficiency, cut costs, and stay competitive. Our AI solutions
          integrate seamlessly with existing systems to deliver faster results
          and smarter decision-making.
        </p>
        <button onClick={() => navigate("/contact")}>
          Schedule a Free AI Consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="ai_sec2">
        <section className="ai_sec2_s1">
          <h4>Why Choose Arshil for AI Development?</h4>
          <p>
            At Arshil, we focus on building practical AI solutions that drive
            real business results. By combining deep expertise with Akscel, our
            intelligent application platform, we help organizations build and
            maintain AI-powered web and mobile applications faster and with
            greater reliability. Our approach is straightforward: automate
            repetitive work, improve operational efficiency, and create scalable
            solutions that deliver measurable value.
          </p>
        </section>

        <section className="ai_sec2_s1_img">
          <img
            className="ai_sec2_gp1_img1"
            src="../images/AI_sec2_gp1_img1.png"
            alt=""
          />
        </section>
      </div>

      {/* setion 2 part 2 */}

      <div className="ai_sec2_g2">
        <section className="AI_sec2_g2_img">
          <img
            className="ai_sec2_gp2_img1"
            src="../images/AI_sec2_gp2_img2.png"
            alt=""
          />
        </section>

        <section className="ai_sec2_g2_C1">
          <h4>The Akscel Advantage</h4>
          <p>
            Akscel is designed to accelerate development by generating
            enterprise-grade code for both web and mobile platforms. It
            integrates directly into CI/CD pipelines, handles code maintenance,
            and ensures continuous testing with minimal human intervention. This
            reduces development time by up to 60%, allowing your teams to focus
            on strategy and innovation rather than manual coding tasks. As we
            advance, Akscel is evolving into a fully AI-driven platform that
            will further streamline workflows and optimize application lifecycle
            management.
          </p>
        </section>
      </div>

      {/* section 2 part 3 */}

      <div className="ai_sec2_g3">
        <section className="ai_sec2_g3_s1">
          <h4>How Akscel Transforms Development</h4>
          <ul className="ai_sec2_g3_s1_ul">
            <li>Generate production-ready code for web and mobile apps</li>
            <li>Automate deployment pipelines and code maintenance</li>
            <li>Reduce time-to-market with pre-built, tested components</li>
            <li>Scale applications as your business grows</li>
            <li>Deliver consistent quality with integrated code analysis</li>
          </ul>
          <button onClick={() => navigate("/contact")}>
            {" "}
            Learn More About Akscel{" "}
            <HiArrowNarrowRight className="psec1arrow" />{" "}
          </button>
        </section>
        <section className="ai_sec2_gp3_img">
          <img
            className="ai_sec2_gp3_img1"
            src="../images/AI_sec2_gp3_img3.png"
            alt=""
          />
        </section>
      </div>

      {/* section 2 part 4 */}

      <div className="ai_sec2_g4">
        <section className="ai_sec2_s1_img">
          <img
            className="ai_sec2_gp4_img1"
            src="../images/AI_sec2_gp4_img4.png"
            alt=""
          />
        </section>

        <section className="ai_sec2_s1">
          <h4>AI Solutions We Offer</h4>
          <p>
            We deliver AI services that adapt to your unique business needs and
            help you stay ahead of the competition:
          </p>
          <ul className="ai_sec2_g3_s1_ul">
            <li>AI-powered web and mobile software.</li>
            <li>Predictive analytics for smarter decision-making</li>
            <li>Natural Language Processing (NLP) for customer experience.</li>
            <li>Generative AI for content and creative tasks</li>
            <li>AI-powered cloud optimization and storage</li>
            <li>Software modernization and AI-driven maintenance.</li>
            <li>Workflow automation for faster operations.</li>
          </ul>
          <button className="ai_sec2_s1_button" onClick={() => navigate("/contact")}>
            Get a free Quote <HiArrowNarrowRight className="psec1arrow" />{" "}
          </button>
        </section>
      </div>

      {/* section 3 */}

      <div className="ai_sec3">
        <section className="ai_sec3_s1">
          <h5>Industries We Serve</h5>
          <img
            className="ai_sec3_img1"
            src="../images/AI_sec3_img.png"
            alt=""
          />
        </section>
      </div>

      {/* FAQ Questions */}

      <div className="F_sec_five">
        <h1>Frequently Asked Questions (FAQs)</h1>
        <div className="Founder-container">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`Founder-item ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <h6
                className="Founder-question"
                onClick={() => toggleAnswer(index)}
              >
                {item.question}
                <span className="Founder-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </h6>
              {activeIndex === index && (
                <p className="Founder-answer">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIandMLsolutions;
